import { render, staticRenderFns } from "./iscritto-stp.html?vue&type=template&id=9f3722d0&"
import script from "./iscritto-stp.vue?vue&type=script&lang=ts&"
export * from "./iscritto-stp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports